import { render } from "./WCToast.vue?vue&type=template&id=39c88e8b"
import script from "./WCToast.vue?vue&type=script&lang=js"
export * from "./WCToast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__